// routes.js
import axios from "axios";
import HomePage from "./pages/Home";
import ErrorPage from "./pages/Error";
import IntroductionPage from "./pages/Introduction";
import UniversityPage from "./pages/University";
import UniversityDetailPage from "./pages/University_detail";
import ContactPage from "./pages/Contact";
import Login from "./pages/admin/Login";
import Dashboard from "./pages/admin/Dashboard";
import ProtectedRoute from "./components/ProtectedRoute";
import DeviceGuard from "./components/DeviceGuard";
import { Navigate } from "react-router-dom";

export const universityDetailLoader = async ({ params }) => {
  const res = await axios.get(
    `https://duhochanquocnewlife.com/api/universities/dai-hoc-han-quoc/${params.url}`
  );

  return res.data.data;
};

const routes = [
  {
    path: "/",
    // element: <RootLayout />,
    errorElement: <ErrorPage />,
    handle: {
      crumb: () => "Trang chủ",
    },
    children: [
      { index: true, element: <HomePage /> },
      {
        path: "gioi-thieu",
        element: <IntroductionPage />,
        handle: {
          crumb: () => "Giới thiệu",
        },
      },
      {
        path: "dai-hoc-han-quoc",
        element: <UniversityPage />,
        handle: {
          crumb: () => "Đại học Hàn Quốc",
        },
      },
      {
        path: "dai-hoc-han-quoc/:url",
        element: <UniversityDetailPage />,
        loader: universityDetailLoader,
        handle: {
          crumb: (data) => data?.name_vn || "Chi tiết trường",
        },
      },
      {
        path: "lien-he",
        element: <ContactPage />,
        handle: {
          crumb: () => "Liên hệ",
        },
      },
      {
        path: "admin",
        children: [
          {
            index: true,
            element: <Navigate to="login" replace />,
          },
          {
            path: "login",
            element: <Login />,
          },
          {
            path: "dashboard",
            element: (
              <DeviceGuard>
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              </DeviceGuard>
            ),
          },
        ],
      }
    ],
  },
];

export default routes;